/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./StateReport.Performance.vue?vue&type=template&id=c38f7962"
import script from "./StateReport.Performance.vue?vue&type=script&lang=js"
export * from "./StateReport.Performance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports